import firebase from "config/firebase";
import { toast } from "react-toastify";
export const getRequestCities =
  (lastDoc = null, onSuccess = () => {}) =>
  async (dispatch) => {
    dispatch({ type: "FETCH_REQUEST_CITIES_PENDING" });
    try {
      const requestCitiesCollectionRef = firebase
        .firestore()
        .collection("requested_locations");
      const requestCitiesLimit = 5;

      let q = requestCitiesCollectionRef
        .orderBy("city", "asc")
        .limit(requestCitiesLimit);

      if (lastDoc) {
        q = q.startAfter(lastDoc);
      }
      
      const querySnapshot = await q.get();
      // const unsubscribe = q.onSnapshot((querySnapshot) => {
        const requestCitiesData = [];
        let lastVisible = null;

        querySnapshot.forEach((doc) => {
          requestCitiesData.push({ id: doc.id, ...doc.data() });
          lastVisible = doc;
        });

        const hasMoreRequestCities = querySnapshot.size >= requestCitiesLimit;

        dispatch({
          type: lastDoc
            ? "FETCH_REQUEST_CITIES_LOAD_MORE_SUCCESS"
            : "FETCH_REQUEST_CITIES_SUCCESS",
          payload: {
            requestCitiesData,
            lastDoc: lastVisible,
            hasMoreRequestCities,
          },
        });

        onSuccess();
      // });

      // return unsubscribe;
    } catch (error) {
      console.error("Error fetching orders:", error.message);
      dispatch({
        type: "FETCH_REQUEST_CITIES_REJECTED",
        error: error.message,
      });
      onSuccess();
    }
  };
export const deleterequestcities = (id) => {
  return async (dispatch) => {
    await firebase
      .firestore()
      .collection("requested_locations")
      .doc(id)
      .delete();
      dispatch({
        type: "DELETE_REQUEST_CITY_SUCCESS",
        payload: id,  // Redux se bhi remove karega
      });

      toast.success("Request Rejected Successfully");
  };
};

export const datachange = (obj, DocID) => async (dispatch) => {
  await firebase
    .firestore()
    .collection("test-colleges-universities")
    .add(obj)
    .then(() => {
      firebase
        .firestore()
        .collection("requested_locations")
        .doc(DocID)
        .delete();

    dispatch({
      type: "ACCEPT_REQUEST_CITY_SUCCESS",
      payload: DocID,  // Redux se remove karega
    });
      toast.success("City Added Successfully");
    });
};
